import { PageContentWrapper } from '@lmc/ui-kit'
import type React from 'react'

interface PageWrapperProps {
  children: React.ReactNode
  testId?: string
}

const PageWrapper = ({ children, testId }: PageWrapperProps) => {
  return (
    <PageContentWrapper data-testid={testId}>{children}</PageContentWrapper>
  )
}

export default PageWrapper
